import { getStorage } from './storage';

export const createHeader = async (
  requireAuthentication: boolean = false,
  useToken: boolean = false,
  encodedFormData: boolean = false
) => {
  let headers: any = {};
  if (encodedFormData) {
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
  } else {
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
  }
  if (requireAuthentication) {
    if (useToken) {
      const token = await getStorage('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } else {
      headers['Authorization'] = process.env.REACT_APP_TOKEN;
    }
  }
  return headers;
}

export const createFormData = async (values: any = null) => {
  let formData = new FormData();
  if (values !== null && typeof values === 'object') {
    for (const key in values) {
      await formData.append(
        (values instanceof FileList) ?
          key.endsWith("[]") ? key : `${key}[]`
          : key
        ,
        (
          values[key] !== null
          && typeof values[key] === 'object'
          && !(values[key] instanceof FileList)
          && !(values[key] instanceof Blob || values[key] instanceof File)
        ) ?
          JSON.stringify(values[key])
          : values[key]
      );
    }
  }
  return formData;
}

export const handleResponseData = (response: any, emptyData: [] | null = null) => {
  return response.data.data ?? emptyData;
}

export const handleResponseError = (response: any) => {
  if (response.response) {
    if (response.response.data) {
      if (response.response.data.error) {
        return response.response.data.error;
      } else {
        return response.response.data;
      }
    } else {
      return response.response.statusText ?? response.response;
    }
  } else {
    return response.error ?? response;
  }
}